module.exports = __webpack_public_path__ + "img/chargingpoint-fastcharger-planned.ac58f83e.svg";